import React from 'react'
import { Modal } from '../components/common/Modal'

interface AboutModalProps {
  isOpen: boolean
  onClose: () => void
}

export function AboutModal({ isOpen, onClose }: AboutModalProps): React.ReactElement {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="About BabyKingdom" size="md">
      <div className="space-y-6">
        <div className="text-center">
          <div className="text-7xl mb-4">🏰</div>
          <h3 className="text-3xl font-black text-purple-700 mb-2">Welcome to BabyKingdom!</h3>
          <p className="text-gray-700 font-bold text-lg">Making Learning Magical for Every Child</p>
        </div>

        <div className="space-y-4">
          <div className="p-4 bg-purple-50 rounded-2xl border-4 border-purple-200">
            <h4 className="font-black text-purple-700 mb-2 text-lg">🎯 Our Mission</h4>
            <p className="text-gray-700 font-semibold">
              We believe every child deserves access to engaging, educational content that makes learning feel like play. BabyKingdom combines gamification with proven learning techniques to help children ages 3-12 develop essential skills while having fun.
            </p>
          </div>

          <div className="p-4 bg-pink-50 rounded-2xl border-4 border-pink-200">
            <h4 className="font-black text-pink-700 mb-2 text-lg">🌟 Why We Exist</h4>
            <p className="text-gray-700 font-semibold">
              Traditional education doesn't always capture children's imagination. We created BabyKingdom to bridge the gap between learning and entertainment, making education an exciting adventure rather than a chore.
            </p>
          </div>

          <div className="p-4 bg-blue-50 rounded-2xl border-4 border-blue-200">
            <h4 className="font-black text-blue-700 mb-2 text-lg">🤝 Our Values</h4>
            <ul className="space-y-2">
              <li className="font-bold text-gray-700">✨ Child-First Design - Every feature prioritizes children&apos;s wellbeing</li>
              <li className="font-bold text-gray-700">🔒 Safety &amp; Privacy - COPPA compliant, no data sold to third parties</li>
              <li className="font-bold text-gray-700">🧠 Evidence-Based Learning - Built with child psychologists and educators</li>
              <li className="font-bold text-gray-700">🌍 Inclusivity - Accessible to children of all abilities and backgrounds</li>
            </ul>
          </div>
        </div>

        <div className="text-center p-6 bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl border-4 border-purple-300">
          <p className="font-bold text-gray-800">
            Founded in 2022, BabyKingdom is used by over 1 million families worldwide.
          </p>
          <p className="text-gray-700 font-semibold mt-3">
            Join us in making learning magical! 🌈
          </p>
        </div>
      </div>
    </Modal>
  )
}
